import React, { useState, useRef, useEffect, useContext } from "react";
//@ts-ignore
import classnames from "classnames";
import api from "../../../../../services/api";
import AuthContext from "../../../../../contexts/Auth";
import SimpleHeader from "../../../../../components/Headers/SimpleHeader";


import MotivosEncerramentos from "./MotivosEncerramentos";
import Estagios from "./Estagios";
//@ts-ignore
import NotificationAlert from "react-notification-alert";
import { HeaderContainer } from "./styles";
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  Nav,
  Row,
  Col,
  NavItem,
  TabContent,
  TabPane,
  NavLink,
  Button,
} from "reactstrap";
import EmpresaContext from "../../../../../contexts/Empresa";
import MarcacaoForm from "../../../../common/Empresas/Marcacoes/index"

// empresaId,
//   history,
//   hiddeTabs = {},
//   externaTabActive,
//   minhaEmpresa,
//   ...props



const ConfiguracoesVendas: React.FC<any> = ({ hiddeTabs, history, ...props }) => {

  const [empresa, setEmpresa] = useState({});
  const [tabActive, setTabActive] = useState("motivosEncerramentos");
  const [headerExtra, setHeaderExtra] = useState<any>(null);
  const [onNovo, setOnNovo] = useState<any>(null);
  const [alert, setAlert] = useState(null);
  const notificationAlert = useRef<any>();
  const { empresaSelecionada } = useContext<any>(EmpresaContext)
  const { hasPermission, hasRole } = useContext(AuthContext);

  var externaTabActive = props.location.state?.externaTabActive ? props.location.state.externaTabActive : null;

  useEffect(() => {
    if (externaTabActive && externaTabActive.length > 0) {
      setTabActive(externaTabActive);
    }
  }, [externaTabActive]);

  // async function loadEmpresa(empresaId:number) {
  //   try {
  //     const response = await api.get(`/common/empresas/${empresaId}`);
  //     setEmpresa(response?.data);
  //   } catch (error) {
  //     console.log(error);
  //     notify("danger", "Não foi possível carregar empresa");
  //   }
  // }

  const notify = (type: any, msg: string) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text" style={{ zIndex: 100 }}>
          <span data-notify="message">{msg}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 3,
    };
    if (notificationAlert.current)
      notificationAlert.current.notificationAlert(options);
  };

  function onEmpresaChange(empresa: any) {
    setEmpresa(empresa ? empresa : {});
  }

  const CustomNavItem = ({ children, disabled, name }: any) => {
    return (
      <>
        <NavItem>
          <NavLink
            href="#"
            role="tab"
            className={classnames("mb-sm-3 mb-md-0 mt-2", {
              active: tabActive === name,
            })}
            onClick={() => setTabActive(name)}
            disabled={disabled}
          >
            {children}
          </NavLink>
        </NavItem>

      </>
    );
  };

  return (
    <>
      {alert}
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlert} />
      </div>
      <SimpleHeader name="Configurações de vendas" parentName="Minha empresa" />
      <div className="w-100">
        <Card>
          <CardHeader className="d-flex justify-content-between align-items-center">
            <h1 className="mb-0">Configurações de vendas</h1>
            <div className="d-flex align-items-center">
              {headerExtra}
              {onNovo && (
                <Button
                  color="primary"
                  type="button"
                  className="btn-icon btn-3 ml-2"
                  size="sm"
                  onClick={onNovo}
                >
                  <span className="btn-inner--icon">
                    <i className="ni ni-fat-add"></i>
                  </span>
                  <span className="btn-inner--text">
                    {tabActive === "motivosEncerramentos" ? "Novo motivo" :
                     tabActive === "marcacoes" ? "Nova tag" : "Novo"}
                  </span>
                </Button>
              )}
            </div>
          </CardHeader>
          <CardBody outline body>
            <Row>
              <Col xs={12} lg={12} md={12} sm={12}>
                <div className="nav-wrapper">
                  <Nav
                    className="nav-fill flex-column flex-md-row"
                    pills
                    role="tablist"
                  >
                    <CustomNavItem
                      name="motivosEncerramentos"
                      disabled={!empresaSelecionada?.id}
                    >
                      <>
                        <i className="fas fa-bookmark mr-2"></i>
                        Motivos de checagem
                      </>
                    </CustomNavItem>
                    <CustomNavItem name="marcacoes" disabled={!empresaSelecionada?.id}>
                      <>
                        <i className="fas fa-tags mr-2"></i>
                        Tags de Oportunidade
                      </>
                    </CustomNavItem>
                  </Nav>
                </div>
                <hr className="m-0" />
                <div>
                  <TabContent activeTab={tabActive}>
                    <TabPane tabId="motivosEncerramentos">
                      {tabActive === "motivosEncerramentos" && empresaSelecionada?.id && (
                        <MotivosEncerramentos
                          {...props}
                          history={history}
                          onEmpresaChange={onEmpresaChange}
                          notify={notify}
                          empresa={empresaSelecionada}
                          isActive={tabActive === "motivosEncerramentos"}
                          setHeaderExtra={setHeaderExtra}
                          setOnNovo={setOnNovo}
                        />
                      )}
                    </TabPane>
                    <TabPane tabId="marcacoes">
                      {tabActive === "marcacoes" && empresaSelecionada?.id && (
                        <MarcacaoForm
                          {...props}
                          history={history}
                          onEmpresaChange={onEmpresaChange}
                          notify={notify}
                          empresa={empresaSelecionada}
                          title={'Tags'}
                          isActive={tabActive === "marcacoes"}
                        />
                      )
                      }
                    </TabPane>

                  </TabContent>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    </>
  );
}
export default ConfiguracoesVendas;
